'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _compose = require('./compose');

var ADD_VIDEO_EVENT = 'bc.addVideo';
var EDIT_VIDEO_EVENT = 'bc.editVideo';
var REMOVE_VIDEO_EVENT = 'bc.removeVideo';
var ADD_VIDEO_ACTION = 'v2-add';
var EDIT_VIDEO_ACTION = 'v2-edit';
var REMOVE_VIDEO_ACTION = 'v2-remove';
var VIDEOS_GTM_CATEGORY = 'v2-videos';

function composeRatingEvent(eventName, action) {
  return (0, _compose.composeEvent)(eventName, {
    gtmValue: 1,
    gtmLabel: undefined,
    gtmCategory: VIDEOS_GTM_CATEGORY,
    gtmAction: action
  });
}

function composeAddVideoEvent() {
  return (0, _compose.composeAnalytics)([composeRatingEvent(ADD_VIDEO_EVENT, ADD_VIDEO_ACTION)]);
}

function composeEditVideoEvent() {
  return (0, _compose.composeAnalytics)([composeRatingEvent(EDIT_VIDEO_EVENT, EDIT_VIDEO_ACTION)]);
}

function composeRemoveVideoEvent() {
  return (0, _compose.composeAnalytics)([composeRatingEvent(REMOVE_VIDEO_EVENT, REMOVE_VIDEO_ACTION)]);
}

exports.default = {
  composeAddVideoEvent: composeAddVideoEvent,
  composeEditVideoEvent: composeEditVideoEvent,
  composeRemoveVideoEvent: composeRemoveVideoEvent,
  ADD_VIDEO_EVENT: ADD_VIDEO_EVENT,
  EDIT_VIDEO_EVENT: EDIT_VIDEO_EVENT,
  REMOVE_VIDEO_EVENT: REMOVE_VIDEO_EVENT,
  ADD_VIDEO_ACTION: ADD_VIDEO_ACTION,
  EDIT_VIDEO_ACTION: EDIT_VIDEO_ACTION,
  REMOVE_VIDEO_ACTION: REMOVE_VIDEO_ACTION,
  VIDEOS_GTM_CATEGORY: VIDEOS_GTM_CATEGORY
};


//////////////////
// WEBPACK FOOTER
// ./~/@bibliocommons/analytics-event-composers/lib/videosEventComposer.js
// module id = 560
// module chunks = 0 2 4 6 7 8 9 10